// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPlan } from './medicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPlan.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Medical Card Finder Result Search Response Model
*/
export class MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModel {
    /**
    * @description Examples: No Match, No Responses, Eligible
    */
    'taskStatus'?: string | null;
    'plans'?: Array<MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPlan> | null;
    /**
    * @description Gets or sets the transaction correlation identifier
    */
    'transactionCorrelationId'?: number;
    /**
    * @description Gets or sets the transaction date time
    */
    'transactionDateTime'?: Moment;
    /**
    * @description Gets or sets the transaction identifier
    */
    'transactionId'?: string | null;
    /**
    * @description Gets or sets the transaction message
    */
    'transactionMessage'?: string | null;
    /**
    * @description Gets or sets the transaction status
    */
    'transactionStatus'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModel>> = [
        {
            "name":     "taskStatus",
            "baseName": "taskStatus",
            "type":     "string"
        },
        {
            "name":     "plans",
            "baseName": "plans",
            "type":     "Array<MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPlan>"
        },
        {
            "name":     "transactionCorrelationId",
            "baseName": "transactionCorrelationId",
            "type":     "number"
        },
        {
            "name":     "transactionDateTime",
            "baseName": "transactionDateTime",
            "type":     "Date"
        },
        {
            "name":     "transactionId",
            "baseName": "transactionId",
            "type":     "string"
        },
        {
            "name":     "transactionMessage",
            "baseName": "transactionMessage",
            "type":     "string"
        },
        {
            "name":     "transactionStatus",
            "baseName": "transactionStatus",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModel.attributeTypeMap;
    }
}
